import React, { useCallback, useEffect, useState } from "react";
import { GameClient } from "../gameClient";

/** @jsx jsx */
import { jsx, css, keyframes } from '@emotion/react';
import { Colors } from "../palettes/colorPalette";
import { backgroundTexture } from "../uiConstants";
import styled from "@emotion/styled";
import { IngameTutorialData } from "../tutorialGraph";
declare var gameClient: GameClient;

const AnimatedDiv = styled.div<{
    radius: number;
}>`
    position: absolute;
    left: 0;
    top: 0;
    z-index: 11;
    width: 100%;
    height: 100%;
    background: ${props => css`radial-gradient(circle,transparent ${props.radius - 40}px, rgba(0, 0, 0, 0.85) ${props.radius}px) right 0% bottom 0%/200% 200%;`};
	transition: background-position .08s ease-in-out;
	background-position: 50% 50%;
`;

const tryItFlash = keyframes`
    0%, 100% { color: #2b95dd; }
    50% { color: #8fd0f5; }
`;

const clickToAdvanceStyle = css`
    font-size: 0.7em;
    color: #5f7280;
    margin-top: 0.1em;
`;

const tryItStyle = css`
    font-size: 0.7em;
    font-weight: bold;
    margin-top: 0.1em;
    animation: ${tryItFlash} 1.2s ease-in-out infinite;
`;

interface ScreenOverlayProps {
    tutorialStepData: IngameTutorialData;
    nextTutorial: () => void;
    requireClick?: boolean;
}

export const ScreenOverlay = (props: ScreenOverlayProps) => {
    const onClick = useCallback((e) => {
        props.nextTutorial();
    }, []);
    return <div onClick={onClick} >
        <AnimatedDiv radius={props.tutorialStepData.radius} style={{
            backgroundPosition: `${props.tutorialStepData.x}% ${props.tutorialStepData.y}%`,
            pointerEvents: props.requireClick ? 'auto' : 'none',
        }} />
        <div style={{
            background: `url(${backgroundTexture})`,
            padding: "0.8vw",
            backgroundColor: Colors.UIBackground,
            filter: `drop-shadow(2px 4px 2px ${Colors.UITextAndBorders})`,
            overflow: 'hidden',
            position: "absolute",
            left: "50%",
            fontSize: "1.5vw",
            top: `${50 + props.tutorialStepData.vOffset}%`,
            transform: "translate(-50%, -50%)",
            zIndex: 12,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
        }}
        >
            <span>{props.tutorialStepData.text}</span>
            {props.tutorialStepData.requireClick ?
                <span css={clickToAdvanceStyle}>(Click to advance)</span> :
                <span css={tryItStyle}>(Try it)</span>
            }
        </div>
    </div>
};